import request from '@/assets/js/request'
import router from '@/router'
const user = {
  state: {
    keywords: '', // 搜索内容
    permissions: '',
    status: false, // 存储登录状态
    cartNum: 0, // 存储购物车数量
    info: {}, // 存储登录用户信息
    isPC: '',
    categoryBanner: '',
    phoneType: '',

    // yiBanToken: '111',
    // yiBanUserInfo: {
    //   yb_userid: 1,
    //   yb_username: '用户名',
    //   yb_usernick: '用户昵称',
    //   yb_sex: '性别',
    //   yb_money: '持有网薪',
    //   yb_exp: '经验值',
    //   yb_userhead: '用户头像',
    //   yb_schoolid: '所在学校id',
    //   yb_schoolname: '所在学校名称'
    // }

    yiBanToken: '',
    yiBanUserInfo: ''
  },

  mutations: {
    // 设置搜索内容
    SET_SEARCH: (state, keywords) => {
      state.keywords = keywords
    },
    // 设置权限
    SET_PERMISSIONS: (state, roles) => {
      state.permissions = roles
    },
    // 设置登录状态
    SET_STATUS: (state, status) => {
      state.status = status
    },
    // 设置购物车数量
    SET_CARTNUM: (state, cartNum) => {
      state.cartNum = cartNum
    },
    // 存储登录用户信息
    SET_INFO: (state, info) => {
      state.info = info
    },
    // 存储分类banner图，供列表页展示
    SET_BANNER: (state, categoryBanner) => {
      state.categoryBanner = categoryBanner
    },
    // 是否是PC
    SET_ISPC: (state, isPC) => {
      state.isPC = isPC
    },
    // 安卓还是IOS
    SET_PHONETYPE: (state, type) => {
      state.phoneType = type
    },
    // 储存易班token
    SET_YIBANTOKEN: (state, data) => {
      state.yiBanToken = data
    },
    // 储存易班用户信息
    SET_YIBANUSERINFO: (state, data) => {
      state.yiBanUserInfo = data
      localStorage.setItem('yiBanUserInfo', JSON.stringify(data))
    }
  },

  actions: {
    // 更新购物车数量
    loadCartNum: ({ commit, state }) => {
      request(`/gateway/order/order/order-cart-item/count`, 'post', {
        userUuid: state.info.id
      }).then(res => {
        let num = res.data ? res.data : 0
        commit('SET_CARTNUM', num)
      })
    },
    // 获取赠品
    loadGifts: async ({ commit }, data) => {
      try {
        // /activity-backend/activity/gift/getGiftBySku
        let res = await request(`/activity-backend/activity/gift/getGiftBySkuId`, 'post', {
          sku: data.id,
          productCategoryId: data.productCategoryId,
          skuId:data.skuId
        })
        return res
      } catch (e) {
      }
    },
    // 跳转登录
    toLogin: () => {
      let href = ''
      if (location.href.indexOf('/#')) {
        href = location.href.split('/#')[1]
      } else {
        // 微信内置浏览器需要授权，授权回来之后，地址格式会被改掉
        href = location.href.split('#/')[1]
      }
      router.push(`/login?redirectUrl=${href}`)
    },
    // 设置订单信息
    setOrderInfo: (state, data) => {
      localStorage.setItem('orderInfo', JSON.stringify(data))
    },
    getPhoneType: ({ commit, state }) => {
      // 判断是否在ios或者安卓打开
      var u = navigator.userAgent
      var isIos = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
      var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1
      if (isIos) {
        commit('SET_PHONETYPE', 'IOS')
      } else if (isAndroid) {
        commit('SET_PHONETYPE', 'Android')
      }
    }
  }
}

export default user



// WEBPACK FOOTER //
// ./src/store/modules/user.js